//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  head () {
    return {
      title: this.getTitle('Klarna FAQs'),
      meta: [
        ...this.getDescription('Questions? We\'re here to help!'),
        { hid: 'og:title', property: 'og:title', content: this.getTitle('Klarna FAQs') }
      ]
    }
  }
}
